import { Theme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles<Theme>()((theme) => ({
  bugReportItemWrapper: {
    ...theme.mixins.appClickableContainer,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',

    '& svg': {
      color: theme.palette.error.main,
    },
  },
  bugReportItemInfo: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(0.5),
  },
}));
